export default function Footer() {
  return (
    <footer className="border-t border-border bg-background" data-testid="site-footer">
      <div className="container mx-auto px-6 md:px-12 py-10 flex flex-col md:flex-row gap-4 items-start md:items-center justify-between font-mono text-[10px] md:text-xs uppercase tracking-[0.3em] text-muted-foreground">
        <p data-testid="footer-brand">SYNCRO<span className="text-primary">/</span>87 — a private collector listing</p>
        <p>Wolfsburg heritage · Built to outlast</p>
        <p>© 2026</p>
      </div>
    </footer>
  );
}
